import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/system";
import { Button, Typography, useMediaQuery } from "@mui/material";
import { IFeatureCardProps } from "../../components/landingPage/featuresCard";
import styles from "./styles";
import feat_img_1 from "assets/landing_feat_1.webp";
import feat_img_2 from "assets/landing_feat_2.webp";
import feat_img_3 from "assets/landing_feat_3.webp";
import feat_landing_mention_rear from "assets/mention_rear.webp";
import feat_landing_mention_front from "assets/mention_front.webp";
import feat_2_front from "assets/landing_feat_2_front.webp";
import feat_2_rear from "assets/landing_feat_2_rear.webp";
import feat_2_bg from "assets/bg_bubble.webp";
import feat_3_bg from "assets/landing_feat_bg_3.webp";
import feat_3_front from "assets/landing_feat_3_front.webp";
import feat_3_rear from "assets/landing_feat_3_rear.webp";
import RocketIcon from "assets/rocket.webp";

import stat_img_1 from "assets/landing_stat_img_1.webp";
import stat_img_2 from "assets/landing_stat_img_2.webp";
import stat_img_3 from "assets/landing_stat_img_3.webp";

import amrPic from "assets/amrPic.webp";
import zeinabBendaryPic from "assets/zeinabBendaryPic.webp";
import ayahYasserPic from "assets/ayahYasserPic.webp";
import alyaAzabPic from "assets/alyaAzabPic.webp";
import islamTarekPic from "assets/islamTarekPic.webp";

import { IStatsCardProps } from "components/landingPage/statsCard";
import PlanCard from "components/landingPage/planCard";
import DrawerAppBar, { Items } from "components/landingPage/NavBar";
import { ITestimonialCard } from "components/landingPage/testimonialCard";
import DemoSection from "components/landingPage/sections/demoSection";
import FeaturesSection from "components/landingPage/sections/featuresSection";
import TestimonialsSection from "components/landingPage/sections/testimonialsSection";
import Footer from "components/landingPage/sections/footer";
import StatsSection from "components/landingPage/sections/statsSection";
import { useRef, useState, useMemo } from "react";
import { useCurrentUser } from "app/appHooks";
import { PATH_NAME } from "routes/pathNames";
import HowItWorksSection from "components/landingPage/sections/HowItWorksSection";
import TrustedBySection from "components/landingPage/sections/trustedBySection";
import { useSubscriptionPlans } from "pages/settings/subscriptionView/hooks";
import BillingToggle, {
  BillingPeriod
} from "components/landingPage/billingToggle";

const features: IFeatureCardProps[] = [
  {
    featureTitle: "Mention A Co-worker",
    featureDescription:
      "Give a shoutout to your coworkers in Slack to show them how you value their contributions",
    featureImg: feat_img_1,
    featureBG: feat_2_bg,
    featureImgFront: feat_landing_mention_front,
    featureImgRear: feat_landing_mention_rear,
    rearStyle: {
      maxWidth: "100%",
      height: "auto",
      width: "527px",
      filter: "drop-shadow(-18px 10px 5px #F2F1FF)",
      borderRadius: "8px",
      marginTop: "120px"
    },
    frontStyle: {
      maxWidth: "100%",
      height: "auto",
      width: "420px",
      filter: "drop-shadow(18px 10px 5px #F2F1FF)",
      borderRadius: "8px",
      top: "285px !important",
      left: { md: "145px !important", xs: "0 !important" },
      "@media (max-width: 460px)": {
        top: "260px !important"
      }
    },
    featureAction: "getStarted"
  },
  {
    featureTitle: "Celebrate with the tops",
    featureDescription:
      "Recognize your team's MVP and see who's crushing it on the leaderboard",
    featureImg: feat_img_2,
    featureBG: feat_2_bg,
    featureImgFront: feat_2_front,
    featureImgRear: feat_2_rear,
    rearStyle: {
      maxWidth: "100%",
      maxHeight: "100%",
      borderRadius: "8px"
    },
    frontStyle: {
      borderRadius: "16px",
      maxWidth: "100%",
      maxHeight: "100%",
      top: "200px !important",
      left: "92px !important",
      "@media (max-width: 460px)": {
        left: "50px !important",
        top: "180px !important"
      }
    }
  },
  {
    featureTitle: "Follow up your progress",
    featureDescription:
      "Stay motivated and on track by following up on your progress",
    featureImg: feat_img_3,
    featureBG: feat_3_bg,
    featureImgFront: feat_3_front,
    featureImgRear: feat_3_rear,
    rearStyle: {
      maxWidth: "100%",
      maxHeight: "100%",
      borderRadius: "8px"
      //   border: "4px"
    },
    frontStyle: {
      borderRadius: "16px",
      maxWidth: "100%",
      maxHeight: "100%",
      top: "100px !important",
      left: "125px !important",
      "@media (max-width: 460px)": {
        left: "85px !important",
        width: "310px"
      }
    }
  }
];
const feedCards: ITestimonialCard[] = [
  {
    userName: "Amr Elsekilly",
    userImg: amrPic,
    withQuote: true,
    userRole: "Team Lead",
    userPost:
      " As a team lead, Hoya helps me observe the psychological state of my team members and how they interact with each other. And it helps strengthen the collaboration state between the team members."
  },
  {
    userName: "Zeinab Bendary",
    userImg: zeinabBendaryPic,
    withQuote: true,
    userRole: "Senior Product Manager",
    userPost:
      "Hoya allows me to show gratitude to my colleagues and receive it as well. It's super easy & quick! With a simple ++ Hoya spreads positivity in the air! As a manager, it provides insightful remarks about the dynamics among the team members. I can spot achievers, appreciators, and popular colleagues."
  },
  {
    userName: "Ayah Yasser",
    userImg: ayahYasserPic,
    withQuote: false,
    userRole: "Product Manager",
    userPost: `As a Product Manager, I love how Hoya helps me applaud team members for hard work, spread positive vibes, and point out the great things we want to keep doing.It helps me communicate appreciation; there's something special about celebrating achievements and even little things, and sharing it with the whole company!
      It's also how I hear about collaboration between team members and amazing things we don't see, and wouldn't know about if not for Hoya :))`
  },
  {
    userName: "Alya Azab",
    userImg: alyaAzabPic,
    withQuote: false,
    userRole: "Software Engineer",
    userPost: `Hoya allows me to quickly show appreciation to my coworkers throughout the day. It helps boost the team's morale and spreads positivity in the workplace!`
  },
  {
    userName: "Islam Tarek",
    userImg: islamTarekPic,
    withQuote: false,
    userRole: "Back-End Engineer",
    userPost: `This app has been a game changer for our company culture. It's made it easy for everyone to show appreciation and recognize each other's hard work. It's a great way to boost team morale and improve employee satisfaction`
  }
];
const stats: IStatsCardProps[] = [
  {
    statDescription:
      "Boost your team's performance by recognising and valuing their hard work",
    statTitle: "Higher Productivity",
    statPercent: "14%",
    statImg: stat_img_1
  },
  {
    statDescription:
      "Experience greater engagement and fulfillment in your work by cultivating a sense of gratitude towards it",
    statTitle: "More Engagement",
    statPercent: "2.7x",
    statImg: stat_img_2
  },
  {
    statDescription:
      "Discover the power of appreciation in building a strong and loyal team",
    statTitle: "Less Turnover",
    statPercent: "31%",
    statImg: stat_img_3
  }
];

const LandingPage = () => {
  const classes = styles();
  const isSM = useMediaQuery("(max-width:1200px)");
  const smPad: string = "24px";
  const widePad = "96px";
  const history = useNavigate();
  const onGetStarted = () => {
    history(user ? PATH_NAME.HOME_PAGE : PATH_NAME.LOGIN);
  };
  const homeRef = useRef<null | HTMLDivElement>(null);
  const { data: user } = useCurrentUser();
  const { data: dataPlans, isLoading: isPlansLoading } = useSubscriptionPlans();
  const [billingPeriod, setBillingPeriod] = useState<BillingPeriod>("monthly");

  // Create free trial plan
  const freeTrialPlan = useMemo(
    () => ({
      priceId: "free-trial",
      planName: "Free Trial",
      planPrice: 0,
      planPeriod: "Trial" as const,
      themeType: "light" as const,
      isCurrentPlan: false,
      isRecommended: false,
      icon: RocketIcon,
      features: [
        "10 ++ recognitions per month",
        "Access to all features",
        "Team leaderboard",
        "Analytics & performance insights",
        "Custom GIFs & reactions"
      ],
      isSubscribed: false,
      isLandingPage: true,
      savedValue: 0,
      savedPercentage: 0
    }),
    []
  );

  // Filter and display plans based on billing period
  const filteredPlans = useMemo(() => {
    if (!dataPlans) return [freeTrialPlan];

    const paidPlans = dataPlans.filter((plan) => {
      if (billingPeriod === "monthly") {
        return plan.planPeriod === "Month";
      } else {
        return plan.planPeriod === "Year";
      }
    });

    return [freeTrialPlan, ...paidPlans];
  }, [freeTrialPlan, dataPlans, billingPeriod]);

  const savingsPercentage = useMemo(() => {
    if (!dataPlans) return 0;
    const yearlyPlan = dataPlans.find((plan) => plan.planPeriod === "Year");
    return yearlyPlan?.savedPercentage || 0;
  }, [dataPlans]);

  const pricingRef = useRef<null | HTMLDivElement>(null);
  const featuresRef = useRef<null | HTMLParagraphElement>(null);
  const howItWorksRef = useRef<null | HTMLParagraphElement>(null);
  const onHomeClick = () => {
    //Fake latency (add to event queue) to run when drawer is unmounted
    setTimeout(() => homeRef?.current?.scrollIntoView({ block: "center" }), 0);
  };
  const onPricingClick = () => {
    //Fake latency (add to event queue) to run when drawer is unmounted
    setTimeout(
      () =>
        pricingRef?.current?.scrollIntoView({
          block: "start",
          behavior: "smooth"
        }),
      0
    );
  };
  const onFeaturesClick = () => {
    //Fake latency (add to event queue) to run when drawer is unmounted
    setTimeout(
      () => featuresRef?.current?.scrollIntoView({ block: "center" }),
      0
    );
  };

  const onHowItWorksClick = () => {
    //Fake latency (add to event queue) to run when drawer is unmounted
    setTimeout(
      () => howItWorksRef?.current?.scrollIntoView({ block: "center" }),
      0
    );
  };

  const navItems: Items[] = [
    { title: "Home", onItemClick: onHomeClick },
    { title: "Features", onItemClick: onFeaturesClick },
    { title: "How it works", onItemClick: onHowItWorksClick }
  ];
  return (
    <>
      <DrawerAppBar navItems={navItems} isSM={isSM} />
      <Stack
        direction="column"
        sx={{
          position: "relative",
          overflowX: "hidden"
        }}
      >
        <DemoSection
          isSM={isSM}
          smPad={smPad}
          onGetStarted={onGetStarted}
          ref={homeRef}
          onPricingClick={onPricingClick}
        />

        <TrustedBySection />

        <FeaturesSection
          ref={featuresRef}
          isSM={isSM}
          features={features}
          widePad={widePad}
          smPad={smPad}
        />

        <HowItWorksSection
          ref={howItWorksRef}
          isSM={isSM}
          widePad={widePad}
          smPad={smPad}
        />

        <TestimonialsSection isSM={isSM} feedCards={feedCards} />

        <Stack
          ref={pricingRef}
          direction={isSM ? "column" : "row"}
          gap={2}
          padding={1}
          width="100%"
          className={classes.plansSectionContainer}
        >
          <Typography className={classes.featureTitle}>
            Our Pricing Plans
          </Typography>

          <BillingToggle
            value={billingPeriod}
            onChange={setBillingPeriod}
            savingsPercentage={savingsPercentage}
          />

          <Stack
            direction={isSM ? "column" : "row"}
            gap={2}
            padding={1}
            width="100%"
            className={classes.plansContainer}
          >
            {isPlansLoading
              ? Array.from(Array(3).keys()).map((i) => (
                  <PlanCard
                    key={i}
                    themeType="light"
                    sx={{ width: isSM ? "100%" : "340px" }}
                    isLoading={isPlansLoading}
                  />
                ))
              : filteredPlans?.map((plan) => (
                  <PlanCard
                    key={plan.priceId}
                    {...plan}
                    sx={{ width: isSM ? "100%" : "340px" }}
                    isLandingPage={true}
                  />
                ))}
          </Stack>
        </Stack>
        <StatsSection
          stats={stats}
          isSM={isSM}
          widePad={widePad}
          smPad={smPad}
        />
        <Button
          onClick={onGetStarted}
          variant="outlined"
          sx={{ marginTop: "64px !important" }}
          className={classes.lightBtn}
        >
          {user ? "View Dashboard" : "Get Started"}
        </Button>
        <Footer isSM={isSM} widePad={widePad} smPad={smPad} />
      </Stack>
    </>
  );
};

export default LandingPage;
